// Auto-generated normalizer for table: Cat_Nivel
export function catNivelNormalize(row) {
  return {
    idNivel: row.idNivel ?? row.IdNivel ?? row['IdNivel'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
